import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { CssBaseline } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { CustomThemeProvider } from '@/theme';
import { ToastContainer } from "react-toastify";

import { AppRouter } from './app/routes';
import './locales';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 0,
    },
    mutations: {
      retry: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <CustomThemeProvider>
        <BrowserRouter>
          <CssBaseline />
          <AppRouter />
        </BrowserRouter>
        
        {/* Toast notifications */}
        <ToastContainer position="top-center" autoClose={1500} />

        {/* React Query Devtools */}
        <ReactQueryDevtools initialIsOpen={false} />
      </CustomThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
